export default __webpack_public_path__ + "74e149e2476be92d43e7aea7d642149f.ttf";